import script from "./PopupCover.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupCover.vue?vue&type=script&setup=true&lang=js"

import "./PopupCover.vue?vue&type=style&index=0&id=033a4595&lang=scss"

const __exports__ = script;

export default __exports__